<template>
  <a-row class="controls" type="flex" justify="space-between">
    <a-col>
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model:value="search" placeholder="Buscar por estrategia" class="form__input">
            <template #prefix>
              <search-outlined />
            </template>
          </a-input>
        </a-form-item>

        <entity-picker
          v-if="user?.customer?.type_business == 1"
          :value="entity"
          @update:value="entity = $event"
          class="form__item"
        />

        <campaign-picker
          :value="portfolio"
          @update:value="portfolio = $event"
          :entity="entity"
          class="form__item"
        />

        <strategy-type-picker :value="type" @update:value="type = $event" showAll />
      </a-form>
    </a-col>
    <a-col>
      <p class="update-text" v-if="isSomeStrategyRunning">
        Actualizando tabla en {{ countToUpdate }} segundos
      </p>

      <div class="update-buttons">
        <a-button type="primary" ghost @click="$emit('update')">Actualizar tabla</a-button>

        <strategy-creator-modal />
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, computed, watch, inject } from "vue";
import { useStore } from "vuex";
import { SearchOutlined } from "@ant-design/icons-vue";
import _ from "lodash";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import StrategyCreatorModal from "@/app/strategies/components/modals/StrategyCreatorModal.vue";
import StrategyTypePicker from "@/app/shared/components/pickers/StrategyTypePicker.vue";

export default defineComponent({
  components: {
    StrategyCreatorModal,
    EntityPicker,
    CampaignPicker,
    StrategyTypePicker,
    SearchOutlined,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const globalFilters = inject("filters");
    const countToUpdate = inject("countToUpdate");
    const isSomeStrategyRunning = inject("isSomeStrategyRunning");
    const globalPagination = inject("pagination");

    const search = ref("");
    const entity = ref(0);
    const portfolio = ref(0);
    const type = ref(0);

    if (user.value) {
      if (user.value.customer.type_business == 2) {
        entity.value = 1;
      }
    }
    watch(user, (newValue) => {
      if (newValue.customer.type_business == 2) {
        entity.value = 1;
      }
    });

    watch(
      () => globalFilters.value?.search,
      (newValue) => {
        if (newValue !== search.value) {
          search.value = newValue || "";
        }
      }
    );

    const handleSearch = () => {
      const filters = {
        search: search.value,
        entity: entity.value,
        portfolio: portfolio.value,
        type: type.value,
      };

      globalFilters.value = filters;
    };

    return {
      countToUpdate,
      isSomeStrategyRunning,
      search,
      entity,
      portfolio,
      type,
      user,
      handleSearch,
    };
  },
  watch: {
    search: _.debounce(function () {
      this.handleSearch();
    }, 500),
    entity() {
      this.handleSearch();
    },
    portfolio() {
      this.handleSearch();
    },
    type() {
      this.handleSearch();
    },
  },
});
</script>

<style lang="sass" scoped>
.form__input
  width: 280px

.form
  &__item
    min-width: 180px

    &--large
      min-width: 260px

.update
  &-buttons
    display: flex
    align-items: center
    gap: 8px

  &-text
    padding: 0
    margin: 0
    color: $gray-7
    font-style: italic
    position: absolute
    top: -28px
    right: 0

.update-buttons
  margin-top: 16px
  gap: 16px
</style>
